import actions from '@/store/modules/verifications/actions';
import getters from '@/store/modules/verifications/getters';
import mutations from '@/store/modules/verifications/mutations';
import state from '@/store/modules/verifications/state';

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state,
};
